import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from "rxjs";
import { LoadingSpinnerService } from "../../services/loading-spinner.service";
import { CookieService } from "angular2-cookie/services/cookies.service";

@Component({
    selector: 'my-loading-spinner',
    template: `
    <div [ngClass]="{'center-vertical': showSpinner}">
    <img *ngIf="showSpinner" src="{{ spinnerUrl }}" id="loading-spinner">
</div>
`,
    styles: [require('./loading-spinner.component.scss')]
})
export class LoadingSpinnerComponent implements OnDestroy {
    showSpinner: boolean;
    subscription: Subscription = new Subscription();

    constructor(
        private spinner: LoadingSpinnerService,
        private cookieService: CookieService
    ) {
        const showLoadingSpinnerSub = this.spinner.showLoadingSpinner.subscribe(x => {
            this.showSpinner = x;
        });
        this.subscription.add(showLoadingSpinnerSub);
    }

    get spinnerUrl() {
        let url = this.cookieService.get('mchSpinnerUrl');
        let isIe = this.isIe;
        return isIe ? url.replace('svg', 'gif') : url;
    }

    get isIe() {
        return !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g) || !!navigator.userAgent.match(/Edge/g);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/loading-spinner/loading-spinner.component.ts